/**
 * Automation Domain Constants
 *
 * Category visual configs and entity type configs used across
 * the shared, rulesList, and ruleDetail subdomains.
 */

import {
  IconPackage,
  IconCoin,
  IconBuildingWarehouse,
  IconFileInvoice,
  IconBell,
  IconTag,
  IconWorld,
  IconBuilding
} from '@tabler/icons-react';
import type { IconProps } from '@tabler/icons-react';
import type { FC } from 'react';

// =============================================================================
// CATEGORY CONFIGURATION
// =============================================================================

export type CategoryConfig = {
  icon: FC<IconProps>;
  labelKey: string;
  color: string;
};

export const CATEGORY_CONFIG: Record<string, CategoryConfig> = {
  publicationStock: {
    icon: IconPackage,
    labelKey: 'automation_category_stock',
    color: 'primary'
  },
  publicationPrice: {
    icon: IconCoin,
    labelKey: 'automation_category_price',
    color: 'primary'
  },
  warehouseStock: {
    icon: IconBuildingWarehouse,
    labelKey: 'automation_category_warehouse_stock',
    color: 'primary'
  },
  invoicing: {
    icon: IconFileInvoice,
    labelKey: 'automation_category_invoicing',
    color: 'primary'
  },
  notification: {
    icon: IconBell,
    labelKey: 'automation_category_notification',
    color: 'primary'
  }
};

// =============================================================================
// ENTITY TYPE CONFIGURATION
// =============================================================================

export type EntityConfig = {
  labelKey: string;
  icon: FC<IconProps>;
};

export const ENTITY_CONFIG: Record<string, EntityConfig> = {
  publication: {
    labelKey: 'automation_entity_publication',
    icon: IconTag
  },
  publicationVariation: {
    labelKey: 'automation_entity_publication_variation',
    icon: IconTag
  },
  item: {
    labelKey: 'automation_entity_item',
    icon: IconPackage
  },
  channel: {
    labelKey: 'automation_entity_channel',
    icon: IconWorld
  },
  account: {
    labelKey: 'automation_entity_account',
    icon: IconBuilding
  },
  warehouse: {
    labelKey: 'automation_entity_warehouse',
    icon: IconBuildingWarehouse
  }
};
